import React from 'react';
// Update this import to get createRoot
import { createRoot } from 'react-dom/client';
import 'bootstrap/dist/css/bootstrap.min.css';
import './assets/scss/style.scss';
import App from './App';
import { Provider } from 'react-redux';
import store from './store';
import FabcoAlerts from './components/FabcoAlerts/FabcoAlerts';
import FabcoLoadingFull from './components/FabcoLoadingFull/FabcoLoadingFull';
import { LanguageProvider } from './context/LanguageContext';

const app = (
  <Provider store={store}>
    <LanguageProvider>
      <FabcoAlerts />
      <FabcoLoadingFull/>
      <App />
    </LanguageProvider>
  </Provider>
);

const container = document.getElementById('root');
const root = createRoot(container);
root.render(app);